// Module
var code = "<div class=\"ups-copyright\"> <div class=\"ups-copyright__logo\" data-region=\"logo\"> <img src=\"&#x2F;images-2&#x2F;ups-logo.svg\" alt=\"UPS\"/> </div> <p class=\"m-0\" data-region=\"text\"></p> </div> ";
// Exports
module.exports = code;